import { Articulation } from 'types/articulation';
import { Precedent } from 'types/precedent';

export type CreditBookmark = {
  creditItemID: string;
  creditType: CreditType;
  timestamp: number;
};

export enum CreditType {
  ARTICULATION = 'ARTICULATION',
  PRECEDENT = 'PRECEDENT',
}

export type ArticulationCreditItem = {
  type: CreditType.ARTICULATION;
  articulation: Articulation;
};

export type PrecedentCreditItem = {
  type: CreditType.PRECEDENT;
  precedent: Precedent;
};

export type DynamicCreditItem = ArticulationCreditItem | PrecedentCreditItem;
